import { useEffect } from "react";
import { useUserStore } from "@/lib/stores/userStore";
import { doc, setDoc } from "firebase/firestore";
import { db } from "@/lib/firebase";

const INTERVAL_MS = 30 * 60 * 1000; // 30 minutes in milliseconds

export const useUpdateActivity = () => {
  const user = useUserStore((state) => state.user);

  useEffect(() => {
    if (!user?.uid || user.role === "GUEST") {
      return;
    }

    const updateActivity = async () => {
      const now = new Date();
      const today = now.toISOString().split("T")[0];
      const currentHour = now.getUTCHours();
      const currentMinute = now.getUTCMinutes();
      const currentHalfHour = currentMinute >= 30 ? "30" : "00";
      const timeKey = `${currentHour.toString().padStart(2, "0")}:${currentHalfHour}`;

      try {
        const activityRef = doc(
          db,
          `users_activity/${today}/${timeKey}/${user.uid}`,
        );
        await setDoc(activityRef, user, { merge: true });
      } catch (error) {
        console.error("Error updating activity:", error);
      }
    };

    // Update immediately
    updateActivity();

    // Set up interval
    const intervalId = setInterval(updateActivity, INTERVAL_MS);

    // Cleanup
    return () => clearInterval(intervalId);
  }, [user]);
};
